import { useEffect, useState, useRef } from 'react';
import Modal from '../../../components/utils/Model';
import { useDispatch, useSelector } from 'react-redux';
import portinActivationAction from '../../../redux/portinActivation/actions';
import Button from '../../../components/utils/Button';
import { useForm } from "react-hook-form";
import { validateZipCode } from '../../../helpers/commonFunction';
import Alert from '../../../components/utils/Alert';

const { closeAddPortinModal, createPortinActivation, getNetworkByDealerPortinMapping, resetMessage, validateEdgeZipCode, resetValidateEdgeZipCode } = portinActivationAction;
const BASE_URL = process.env.REACT_APP_BASEURL;

const AddPortinActivation = ({ search }) => {
    const dispatch = useDispatch();
    const { openPortinModal, portinNetworkList, createPortinActivationError, createPortinActivationLoading, createPortinActivationMessage, validateZipLoading, validateZipMessage, validateZipError } = useSelector((state) => state.portinActivation);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const [stepFlag, setStepFlag] = useState(false);
    const [selectedNetwork, setSelectedNetwork] = useState(null);
    const [formData, setFormData] = useState(null);
    const [zipCheckStatus, setZipCheckStatus] = useState('idle');
    const lastCheckedZip = useRef(null);
    const { register, handleSubmit, formState: { errors }, trigger, reset, setError, clearErrors, getValues } = useForm();

    useEffect(() => {
        dispatch(getNetworkByDealerPortinMapping());
        reset();
    }, [dispatch]);

    useEffect(() => {
        if (createPortinActivationError !== null && createPortinActivationError !== undefined) {
            displayAlert(createPortinActivationError, 'alert-danger');
        }
        if (createPortinActivationMessage !== null && createPortinActivationMessage !== undefined) {
            reset();
            setStepFlag(false)
        }
    }, [createPortinActivationError, createPortinActivationMessage]);

    useEffect(() => {
        if (validateZipMessage !== null && validateZipMessage !== undefined) {
            clearErrors('zipCode');
            setZipCheckStatus('valid');
            dispatch(resetValidateEdgeZipCode());
        }
        if (validateZipError !== null && validateZipError !== undefined) {
            setError('zipCode', { type: 'manual', message: validateZipError });
            setZipCheckStatus('invalid');
            dispatch(resetValidateEdgeZipCode());
        }
    }, [validateZipMessage, validateZipError]);


    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetMessage());
    }


    const handleCancel = () => {
        dispatch(closeAddPortinModal());
        reset();
        setStepFlag(false)
        alertCancel();
    }

    const handleZipBlur = (e) => {
        const zipValue = e.target.value;
        const selected = portinNetworkList?.find(n => n.NetworkID === selectedNetwork);
        if (!zipValue || !validateZipCode(zipValue)) {
            return;
        }

        if (selected?.NetworkID == 9 && selected?.PortPrefferedAggregator == 14) {
            if (lastCheckedZip.current === zipValue && zipCheckStatus === 'valid') {
                return;
            }
            lastCheckedZip.current = zipValue;
            setZipCheckStatus('checking');
            dispatch(validateEdgeZipCode({ zipCode: zipValue }));
        } else {
            setZipCheckStatus('idle');
        }
    };

    const onSubmit = (data) => {
        const selected = portinNetworkList.find(n => n.NetworkID === selectedNetwork);
        const finalData = {
            ...data,
            networkID: selected?.NetworkID,
            NetworkName: selected?.NetworkName,
        };

        const needsApiCheck = selected?.NetworkID == 9 && selected?.PortPrefferedAggregator == 14;

        if (needsApiCheck && zipCheckStatus !== 'valid') {
            if (zipCheckStatus !== 'checking') {
                lastCheckedZip.current = data.zipCode;
                setZipCheckStatus('checking');
                dispatch(validateEdgeZipCode({ zipCode: data.zipCode }));
            }
            return;
        }

        setFormData(finalData);
        setStepFlag(true);
    };

    // const onSubmit = (data) => {
    //     const selected = portinNetworkList.find(n => n.NetworkID === selectedNetwork);
    //     const finalData = {
    //         ...data,
    //         networkID: selected?.NetworkID,
    //         NetworkName: selected?.NetworkName,
    //     };
    //     setFormData(finalData);
    //     setStepFlag(true);
    // };

    const handleback = () => {
        setStepFlag(false)
        alertCancel();
    }

    const handleFinalSubmit = () => {
        const newData = {
            networkID: formData.networkID,
            zipCode: formData.zipCode,
            simType: formData.networkID == 12 ? 26 : 25,
            quantity: formData.quantity
        };
        dispatch(createPortinActivation(newData, search));
    };

    return (
        <Modal
            showModal={openPortinModal}
            title={stepFlag ? "Confirm Portin" : "Add Portin"}
            onHide={handleCancel}
            width={600}
            showFooter={false}
        >
            {showAlert && <div className='mt-4'><Alert type={alertType} text={alertText} closeBtn={alertCancel} /></div>}
            <div className='parentStepLine'>
                <div className='circle1'><span style={{ textAlign: "center", fontSize: "16px", color: '#fff' }}>1</span></div>
                <div className={stepFlag ? 'steplineConfirm' : 'stepline'}></div>
                <div className={stepFlag ? 'circle2Confirm' : 'circle2'}><span style={{ textAlign: "center", fontSize: "16px", color: '#fff' }}>2</span></div>
            </div>
            {stepFlag ?
                <div>
                    <div className='lit-one-model'>
                        <div className='list-item-main'>
                            <span className='span-one'>Network</span>
                            <span className='span-two'>{formData.NetworkName}</span>
                        </div>
                        <div className='list-item-main'>
                            <span className='span-one'>Price</span>
                            <span className='span-two'> ${parseFloat(portinNetworkList.find(n => n.NetworkID === formData.networkID)?.DealerPrice || 0).toFixed(2)} </span>
                        </div>
                        <div className='list-item-main'>
                            <span className='span-one'>Quantity</span>
                            <span className='span-two'>X {formData.quantity}</span>
                        </div>
                        <div className='list-item-main' style={{ border: 'none' }}>
                            <span style={{ fontWeight: "600", color: '#000', fontSize: '18px' }}>Grand Total</span>
                            <span style={{ fontWeight: "600", color: '#990404', fontSize: '18px' }}> ${((portinNetworkList.find(n => n.NetworkID === formData.networkID)?.DealerPrice || 0) * (formData.quantity || 0)).toFixed(2)} </span>
                        </div>
                    </div>
                    <hr />
                    <div className="d-flex mb-3 mt-4" style={{ gap: "10px" }}>
                        <button type="button" className="btn btn-secondary flex-fill me-1" onClick={handleCancel}>Close</button>
                        <button type="button" className="btn btn-secondary flex-fill me-1" onClick={handleback}>Back</button>
                        <Button title={"Submit"} style="minWidth:0" onClick={handleFinalSubmit} loading={createPortinActivationLoading} buttonClass="btn btn-primary flex-fill ms-1" buttonType='submit' />
                    </div>
                </div>
                : <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-row">
                        <div className="col-md-12 mb-3">
                            <div className="d-flex justify-content-center flex-wrap" style={{ gap: "10px" }}>
                                {portinNetworkList && portinNetworkList.length > 0 ? (
                                    portinNetworkList.map((network) => (
                                        <label
                                            key={network.ID}
                                            className={`network-card text-center p-2 rounded border ${selectedNetwork === network.NetworkID ? 'selected' : ''}`}
                                            style={{ cursor: "pointer", width: "175px", height: "100px", boxShadow: "0 0 6px rgba(0,0,0,0.1)", transition: "0.2s ease-in-out" }}
                                            onClick={() => {
                                                setSelectedNetwork(network.NetworkID);
                                                trigger("networkID");
                                                clearErrors("zipCode");
                                                setZipCheckStatus('idle');
                                                lastCheckedZip.current = null;
                                                const zipValue = getValues("zipCode");
                                                if (zipValue && validateZipCode(zipValue) && network.NetworkID == 9 && network.PortPrefferedAggregator == 14) {
                                                    lastCheckedZip.current = zipValue;
                                                    setZipCheckStatus('checking');
                                                    dispatch(validateEdgeZipCode({ zipCode: zipValue }));
                                                }
                                            }}
                                        >
                                            <input
                                                type="radio"
                                                value={network.NetworkID}
                                                className="d-none"
                                                {...register("networkID", { required: "Network is required !" })}
                                            />
                                            <img src={`${BASE_URL}/networks/${network.NetworkLogoURL}?${Date.now()}`} alt={network.NetworkName} width={150} height={70} className="mb-2" style={{ objectFit: "fill" }} />
                                            {/* <div className="fw-semibold" style={{ fontSize: "18px", color: '#30093e' }}>{network.NetworkName}</div> */}
                                            <div className="check-overlay"></div>
                                        </label>

                                    ))
                                ) : (
                                    <p className="text-muted">No networks available</p>
                                )}
                            </div>

                            {errors && errors.networkID && (
                                <div className="invalid-feedback d-block text-center">
                                    {errors.networkID.message}
                                </div>
                            )}
                        </div>


                        {/* <div className="col-md-12 mb-3">
                            <label>ZIP Code <span className='text-danger'>*</span></label>
                            <input type="number" className="form-control" placeholder="Enter Your Area Code" onWheel={(e) => e.target.blur()} onKeyDown={(e) => ['ArrowUp', 'ArrowDown'].includes(e.key) && e.preventDefault()} name="zipCode" {...register("zipCode", {
                                required: "Area code is required!",
                                validate: (val) => {
                                    if (val && !validateZipCode(val)) {
                                        return "Invalid ZIP Code";
                                    }
                                    return true;
                                }
                            })}
                            />
                            {errors.zipCode && (<div className="invalid-feedback">{errors.zipCode.message}</div>)}
                        </div> */}
                        <div className="col-md-12 mb-3">
                            <label>ZIP Code <span className='text-danger'>*</span></label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Enter Your Area Code"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => ['ArrowUp', 'ArrowDown'].includes(e.key) && e.preventDefault()}
                                name="zipCode"
                                {...register("zipCode", {
                                    required: "Area code is required!",
                                    validate: (val) => {
                                        if (val && !validateZipCode(val)) {
                                            return "Invalid ZIP Code";
                                        }
                                        return true;
                                    },
                                    onChange: () => {
                                        if (zipCheckStatus !== 'idle') {
                                            setZipCheckStatus('idle');
                                            clearErrors('zipCode');
                                        }
                                    }
                                })}
                                onBlur={handleZipBlur}
                            />
                            {errors.zipCode && (<div className="invalid-feedback">{errors.zipCode.message}</div>)}
                            {zipCheckStatus === 'checking' && (
                                <small className="text-primary d-block mt-1">
                                    <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                    Checking ZIP code...
                                </small>
                            )}
                        </div>

                        <div className="col-md-12 mb-3">
                            <label>Quantity <span className='text-danger'>*</span></label>
                            <input type="text" placeholder="Enter Quantity" className={"form-control"} name="quantity" {...register("quantity", {
                                required: "Quantity is required!",
                                pattern: { value: /^[0-9]+$/, message: "Only numeric values are allowed" },
                                max: { value: 300, message: "Quantity cannot exceed 300" },
                                min: { value: 1, message: "Quantity must be at least 1" }

                            })}
                                onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ''); }} />
                            {errors?.quantity && (<div className="invalid-feedback">{errors.quantity.message}</div>)}
                        </div>

                    </div>

                    <hr />
                    <div className="d-flex mb-3" style={{ gap: "10px" }}>
                        <button type="button" className="btn btn-secondary flex-fill me-1" onClick={handleCancel}>Close</button>
                        <Button title={"Next"} style="minWidth:0" buttonClass="btn btn-primary flex-fill ms-1" buttonType='submit' loading={validateZipLoading || zipCheckStatus === 'checking'} />
                    </div>

                </form>}
        </Modal>
    )
}

export default AddPortinActivation;
